export default {
  id: 160,
  title: 'Target #160 - Donut',
  url: 'https://cssbattle.dev/play/160',
  colors: ['#62306D', '#F7EC7D', '#E38F66'],
  solution:
    '<a><style>body{background:#62306d}a{box-sizing:border-box;display:block;position:fixed;top:50;left:100;width:200;height:200;border:40px solid;border-color:#f7ec7d #f7ec7d #f7ec7d #e38f66;border-radius:9in;transform:rotate(45deg)}</style>',
}
